import { useQuery } from '@tanstack/react-query';
import { getCustomLogo } from '../utils';
import { CustomLogoProps } from '../types';

const LOGO_PATH = 'logo';
const ICON_LOGO_PATH = 'icon-logo';

type LogosData = {
  fullLogo?: CustomLogoProps;
  iconLogo?: CustomLogoProps;
};

export const useLogos = () => {
  return useQuery({
    queryKey: ['custom-logos'],
    queryFn: async (): Promise<LogosData> => {
      const [fullLogoResult, iconLogoResult] = await Promise.allSettled([
        getCustomLogo(LOGO_PATH),
        getCustomLogo(ICON_LOGO_PATH),
      ]);

      const logos: LogosData = {};

      if (fullLogoResult.status === 'fulfilled' && fullLogoResult.value) {
        logos.fullLogo = fullLogoResult.value;
      }

      if (iconLogoResult.status === 'fulfilled' && iconLogoResult.value) {
        logos.iconLogo = iconLogoResult.value;
      }

      return logos;
    },
  });
};
